export default __webpack_public_path__ + "static/media/6.4.83d0a11c.jpg";